import { RoutineType, WorkspaceAsset, WorkspaceRoutine } from '@gripp/shared-logic';
import { AlertType } from './types';

export const getCounterRoutinesForOnInterval = (
  workspaceAsset: WorkspaceAsset
): WorkspaceRoutine[] => {
  const counterTypeRoutines =
    workspaceAsset.routines?.filter(
      (routine) => routine.type === RoutineType.Counter
    ) || [];

  const counterRoutinesWithState = counterTypeRoutines.map((routine) => {
    const routineId = routine.id;
    const state = workspaceAsset.routineState?.find(
      (s) => routineId === s.workspaceRoutineId
    );
    return { ...routine, state: state?.state };
  });

  return counterRoutinesWithState;
};

export const getAlertType = (key: string) => {
  switch (key) {
    case 'onDate':
      return AlertType.Date;
    case 'dayIntervalUnit':
      return AlertType.RecurringInterval;
    case 'daysSinceCompleted':
      return AlertType.DaysSkipped;
    case 'onCompletionCount':
      return AlertType.RoutineCompletions;
    case 'floor':
      return AlertType.Max;
    case 'ceiling':
      return AlertType.Min;
    case 'every':
      return AlertType.Days;
    case 'onInterval':
      return AlertType.Interval;
    default:
      return undefined;
  }
};